<template>
  <TextField
    id="mealplan-webview-url"
    :name="`${formNamespace}keystore.webview`"
    :label="t('sites.singleSite.financialConfig.mealPlans.form.webview')"
    :placeholder="t('sites.singleSite.financialConfig.mealPlans.form.webviewPlaceholder')"
    :disabled="!editMealPlan"
    :required="editMealPlan"
  />
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n';
import { storeToRefs } from 'pinia';
import { useFinancialConfigStore } from '../../../../../../routes';
import { inject } from 'vue';

// Set localization
const { t } = useI18n();

// Set financial config store
const fConfigStore = useFinancialConfigStore();
const { editMealPlan } = storeToRefs(fConfigStore);

const formNamespace = inject('formNamespace', '');
</script>
